import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import ScheduleComponent from './schedule-component';

import {
  Loader,
  ContainerLoader,
} from './styles';

import {
  signInSchedule,
  signOut,
} from '../../../core/actions';
import { getSegmentById } from './graphql';

const Schedule = (props) => {
  const {
    location,
    onSignIn,
    onSignOut,
    authentication: { scope },
  } = props;

  const history = useHistory();

  const [loader, setLoader] = useState(true);
  const [segment, setSegment] = useState({});

  const { segment_id: segmentId } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const handleSignIn = useCallback(async () => {
    try {
      if (scope !== 'tester') {
        await onSignIn(segmentId);
      }

      const { segment: segmentData } = await getSegmentById(segmentId);
      setSegment(segmentData);

      setLoader(false);
    } catch (ex) {
      setLoader(false);
      onSignOut();
      history.push('/');
    }
  }, [scope, segmentId, onSignIn, onSignOut, history]);

  useEffect(() => {
    handleSignIn();
  }, [handleSignIn]);

  if (loader) {
    return (
      <ContainerLoader>
        <Loader data-loader="schedule-loader" />
      </ContainerLoader>
    );
  }

  return (
    <ScheduleComponent
      segment={segment}
      location={location}
      history={history}
    />
  );
};

Schedule.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  onSignIn: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
  authentication: PropTypes.shape({
    scope: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  authentication,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onSignIn: signInSchedule,
  onSignOut: signOut,
}, dispatch);

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(Schedule);
